import { Fragment, PureComponent } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import throttle from 'lodash-es/throttle';
import noop from 'lodash-es/noop';

import Icon from 'components/Icon';

class NavList extends PureComponent {
  static propTypes = {
    root: PropTypes.string,
    linkClasses: PropTypes.exact({
      className: PropTypes.string,
      activeClassName: PropTypes.string,
    }),
    accordionClass: PropTypes.string,
    onToggle: PropTypes.func,
  };

  static defaultProps = {
    linkClasses: {
      className: 'tab-menu__item-text',
      activeClassName: 'tab-menu__item-text_active',
    },
    accordionClass: 'tab-menu_opened',
    onToggle: noop,
  };

  constructor(props) {
    super(props);

    this.state = {
      isButtonShown: document.body.clientWidth < 1025,
      buttonText: this.getButtonText(),
      isOpened: false,
    };

    this.throttledHandleButtonShow = throttle(this.handleButtonShow, 200);
  }

  componentDidMount() {
    window.addEventListener('resize', this.throttledHandleButtonShow);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.throttledHandleButtonShow);
  }

  componentDidUpdate(prevProps) {
    const path = this.props.location.pathname.split('/')[1];
    const prevPath = prevProps.location.pathname.split('/')[1];

    if (path !== prevPath) {
      return;
    }

    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({ buttonText: this.getButtonText() });
    }
  }

  handleButtonShow = () => {
    if (this.state.isButtonShown !== document.body.clientWidth < 1025) {
      this.setState((prevState) => ({
        isButtonShown: !prevState.isButtonShown,
      }));
    }
  };

  getButtonText() {
    const { location, root, tabs } = this.props;

    return (
      tabs.find((tab) => tab.link && location.pathname.includes(tab.link)) ||
      tabs.find(() => location.pathname.includes(root))
    ).text;
  }

  toggleMenu = () => {
    const { onToggle } = this.props;
    const { isButtonShown, isOpened } = this.state;
    if (isButtonShown) {
      this.setState({ isOpened: !isOpened }, () => onToggle(!isOpened));
    }
  };

  handleNavButtonClick = (e) => {
    this.toggleMenu();
    this.props.onClick && this.props.onClick(e);
  };

  render() {
    const { isButtonShown, buttonText, isOpened } = this.state;
    const {
      tabs,
      root,
      listClassName,
      linkClasses,
      accordionClass,
    } = this.props;

    return (
      <div className="section__nav">
        {isButtonShown && (
          <button className="btn tab-menu__btn" onClick={this.toggleMenu}>
            <span className="tab-menu__btn-text">{buttonText}</span>
            <Icon className="tab-menu__icon" icon="arrow-opening" />
          </button>
        )}
        <ul
          className={cx('tab-menu', listClassName, {
            [accordionClass]: isOpened,
          })}
        >
          {tabs.map((tab, key) => (
            <li
              className="tab-menu__item"
              key={key}
              onClick={this.handleNavButtonClick}
            >
              <NavLink
                {...linkClasses}
                exact={key === 0}
                to={`/${root}${tab.link}`}
              >
                {tab.text}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default withRouter(NavList);
